module.exports = __webpack_public_path__ + "static_1727318417925/img/giftModule1.d7174ccf.png";